import React from 'react'
import { Link } from 'react-router-dom';
function ServiceTen() {
    return (
        <div>
            {/* our service area start */}
            <div className="rts-service-area rts-section-gapTop pb--200 service-two-bg bg_image">
                <div className="container">
                    <div className="row g-5 service padding-controler">
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail">
                                    <img src="assets/images/service/02.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Strategy Growth</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail two">
                                    <img src="assets/images/service/03.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Grow Business</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail three">
                                    <img src="assets/images/service/04.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Proudly Speech</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--100">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail">
                                    <img src="assets/images/service/02.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Model Building</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--60">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail two">
                                    <img src="assets/images/service/03.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Solution Model</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                        {/* single service area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12 pb--140 pb_md--60 pb_sm--60">
                            <div className="service-two-inner">
                                <Link to={'/service-details'} className="thumbnail three">
                                    <img src="assets/images/service/04.jpg" alt="Business_image" />
                                </Link>
                                <div className="body-content">
                                    <div className="hidden-area">
                                        <h5 className="title">Finbiz Solution</h5>
                                        <p className="dsic">
                                            Porta sagittis diam imperdiet eu, tempus nisi aenean vehicula
                                            torquent dis mattis nullam bibendum morbi laoreet lobortis id
                                        </p>
                                        <Link
                                            className="rts-read-more-two color-primary"
                                            to={'/service-details'}
                                        >
                                            Read More
                                            <i className="far fa-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* single service area end*/}
                    </div>
                </div>
            </div>
            {/* our service area end */}
        </div>
    )
}

export default ServiceTen